const brandList = [
    { name: 'Dry Fruit Wala', },
    { name: 'Urban Platter', },
    { name: 'Nutshellz', },
    { name: 'Nutty Gritties', },
    { name: 'Tulshi', },
    { name: 'Nutshine', },
]

export default brandList;